var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_vm._l((_vm.headers),function(th,i){return [(_vm.isString(th))?_c('th',{domProps:{"innerHTML":_vm._s(th)}}):_c('component',_vm._b({},'component',_vm.$_thAttributes(th, i),false))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }